<script>
  import { mapGetters } from 'vuex'
  import VCheckbox from '@components/Checkbox'
  export default {
    name: 'Area',
    components: { VCheckbox },
    template: '#template_modulkonfigurator_panel',
    props: {
      areaKey: {
        type: String,
        required: true
      },
      areaKeyBefore: {
        type: [String]
      }
    },
    data () {
      return {
          currentSelect: [],
        uid: null,
        open: false,
        isOpenExternal: false,
        maxReachedTrigger: false
      }
    },
    computed: {
      ...mapGetters(['form']),
      maxModules () {
        let value = 0
        this.area.validators.forEach((v) => {
          if (v.key === 'max') {
            value = v.value
          }
        })
        return value
      },
      initiallyLocked () {
        return this.area.selectedModules == this.area.submodules.length
      },
      panelClass () {
        let result = []
        result.push('panel-default')
        if (this.disabled || this.area.valid === false) {
          result.push('panel-danger')
        }
        else if (this.area.valid) {
          result.push('panel-success')
        }
        result.push(this.open && this.accessAllowed ? 'panel--open' : 'panel--close')
        return result.join(' ')
      },
      bodyClass () {
        let result = []
        if (!this.accessAllowed) {
          result.push('hidden')
        }
        result.push(this.open ? 'in' : '')
        return result.join(' ')
      },
      area () {
        const self = this
        let area = self.form.allAreas.find((area) => {
          return area.id === self.areaKey
        })
        return area
      },
      areaBefore () {
        const self = this
        let area = self.form.allAreas.find((area) => {
          return area.id === self.areaKeyBefore
        })
        return area
      },
      accessAllowed () {
        const self = this
        let area = self.areaBefore
        if (area) {
          return area.valid
        }
        else {
          return true
        }
      }
    },
    mounted () {
      this.uid = this._uid
      this.open = !this.areaKeyBefore
    },
    methods: {
      maxReached () {
        const self = this
        let maxValidator = self.area.validators.find((item) => {
          return item.key === 'max'
        })

        if (!maxValidator) {
          return false
        }

        if (maxValidator.value === self.area.selectedModules) {
          return true
        }

        return false
      },
      togglePanel () {
// console.log(this.area.name)
        this.open = !this.open
      }
    },
    watch: {
      /*
      'area.valid' (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.areaBefore && this.areaBefore.valid === true) {
            this.open = true
          }
        }
      },
      */
      areaBefore (newVal, oldVal) {
        if (newVal && newVal.valid === true && oldVal.valid === false) {
          this.open = true
        }
      }
    }
  }
</script>
